import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { OrganizationService } from './organization.service';

@Injectable()
export class OrganizationResolver implements Resolve<any[]> {

    constructor(private organizationService: OrganizationService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {

        const id = +route.params['id'];

        return this.organizationService.get({id: id});
    }

}
